import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../../../components/layout/Layout';

type TipoRegistro = 'produto' | 'servico';
type MetodoImportacao = 'manual' | 'csv' | 'api';

interface RegistroProduto {
  id: string;
  // Identificação da Venda
  dataVenda: string;
  numeroContrato: string;
  numeroNFe: string;
  idVenda: string;
  // Cliente
  clienteNome: string;
  clienteCpfCnpj: string;
  // Participante
  participanteCpf: string;
  participanteNome: string;
  // Produto Vendido
  codigoProduto: string;
  descricaoProduto: string;
  quantidade: number;
  valorUnitario: number;
  valorTotal: number;
  // Pagamento
  dataVencimento: string;
  dataPagamento: string;
  // Informações
  observacoes: string;
  // Metadata
  dataCriacao: Date;
  status: 'Pendente' | 'Aprovado' | 'Rejeitado';
}

interface RegistroServico {
  id: string;
  // Identificação do Serviço
  dataServico: string;
  numeroContrato: string;
  numeroOS: string;
  numeroNFSe: string;
  // Cliente
  clienteNome: string;
  clienteCpfCnpj: string;
  // Participante
  participanteCpf: string;
  participanteNome: string;
  // Serviço Executado
  codigoServico: string;
  tipoDescricaoServico: string;
  valorServico: number;
  // Pagamento
  dataVencimento: string;
  dataPagamento: string;
  // Informações
  observacoes: string;
  // Metadata
  dataCriacao: Date;
  status: 'Pendente' | 'Aprovado' | 'Rejeitado';
}

export default function PerformancePage() {
  const navigate = useNavigate();
  const [tipoRegistro, setTipoRegistro] = useState<TipoRegistro>('produto');
  const [metodoImportacao, setMetodoImportacao] = useState<MetodoImportacao | null>(null);
  const [showModalRegistro, setShowModalRegistro] = useState(false);
  const [showFormularioManual, setShowFormularioManual] = useState(false);
  const [showModalDetalhes, setShowModalDetalhes] = useState(false);
  const [showModalExcluir, setShowModalExcluir] = useState(false);
  const [showModalImportacao, setShowModalImportacao] = useState(false);
  const [showModalAPI, setShowModalAPI] = useState(false);
  const [registroSelecionado, setRegistroSelecionado] = useState<any>(null);
  const [modoEdicao, setModoEdicao] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filtroStatus, setFiltroStatus] = useState('todos');
  const [filtroTipo, setFiltroTipo] = useState('todos');

  // Lista de participantes (mock - mesma estrutura da página de lista)
  const mockParticipantes = [
    {
      id: '1',
      nome: 'Ana Silva',
      email: 'ana.silva@empresa.com',
      cpf: '123.456.789-01',
      departamento: 'Vendas',
      cargo: 'Consultora de Vendas'
    },
    {
      id: '2',
      nome: 'Carlos Eduardo Lima',
      email: 'carlos.lima@empresa.com',
      cpf: '987.654.321-02',
      departamento: 'Marketing',
      cargo: 'Analista de Marketing'
    },
    {
      id: '3',
      nome: 'Mariana Santos',
      email: 'mariana.santos@empresa.com',
      cpf: '456.789.123-03',
      departamento: 'RH',
      cargo: 'Coordenadora de RH'
    },
    {
      id: '4',
      nome: 'Pedro Oliveira',
      email: 'pedro.oliveira@empresa.com',
      cpf: '789.123.456-04',
      departamento: 'TI',
      cargo: 'Desenvolvedor'
    },
    {
      id: '5',
      nome: 'Juliana Rodrigues',
      email: 'juliana.rodrigues@empresa.com',
      cpf: '321.654.987-05',
      departamento: 'Financeiro',
      cargo: 'Analista Financeiro'
    },
    {
      id: '6',
      nome: 'Fernanda Lima',
      email: 'fernanda.lima@empresa.com',
      cpf: '654.987.321-06',
      departamento: 'Marketing',
      cargo: 'Supervisora de Marketing'
    },
    {
      id: '7',
      nome: 'Roberto Costa',
      email: 'roberto.costa@empresa.com',
      cpf: '159.753.486-07',
      cnpj: '12.345.678/0001-90',
      departamento: 'Vendas',
      cargo: 'Gerente de Vendas'
    },
    {
      id: '8',
      nome: 'Camila Souza',
      email: 'camila.souza@empresa.com',
      cpf: '159.753.486-08',
      departamento: 'RH',
      cargo: 'Analista de RH'
    },
    {
      id: '9',
      nome: 'Rafael Barbosa',
      email: 'rafael.barbosa@empresa.com',
      cpf: '753.159.486-09',
      departamento: 'Operações',
      cargo: 'Coordenador de Operações'
    },
    {
      id: '10',
      nome: 'Thiago Pereira',
      email: 'thiago.pereira@empresa.com',
      cpf: '486.159.753-10',
      departamento: 'Vendas',
      cargo: 'Consultor de Vendas'
    },
    {
      id: '11',
      nome: 'Lucas Martins',
      email: 'lucas.martins@empresa.com',
      cpf: '369.258.147-11',
      departamento: 'TI',
      cargo: 'Analista de Sistemas'
    },
    {
      id: '12',
      nome: 'Beatriz Almeida',
      email: 'beatriz.almeida@empresa.com',
      cpf: '258.147.369-12',
      departamento: 'Atendimento',
      cargo: 'Supervisora de Atendimento'
    }
  ];

  // Estados para busca de participante
  const [buscaParticipante, setBuscaParticipante] = useState('');
  const [showDropdownParticipante, setShowDropdownParticipante] = useState(false);
  const [participantesFiltrados, setParticipantesFiltrados] = useState(mockParticipantes);

  // Função para buscar participantes
  const handleBuscaParticipante = (valor: string) => {
    setBuscaParticipante(valor);
    
    if (valor.trim() === '') {
      setParticipantesFiltrados(mockParticipantes);
      setShowDropdownParticipante(false);
      return;
    }

    const filtrados = mockParticipantes.filter(p => 
      p.nome.toLowerCase().includes(valor.toLowerCase()) ||
      p.cpf.includes(valor) ||
      p.email.toLowerCase().includes(valor.toLowerCase()) ||
      p.departamento.toLowerCase().includes(valor.toLowerCase())
    );

    setParticipantesFiltrados(filtrados);
    setShowDropdownParticipante(true);
  };

  // Função para selecionar participante
  const handleSelecionarParticipante = (participante: any) => {
    setNovoRegistro({
      ...novoRegistro,
      cpfParticipante: participante.cpf,
      nomeParticipante: participante.nome
    });
    setBuscaParticipante(participante.nome);
    setShowDropdownParticipante(false);
  };

  // Estados para produtos/serviços cadastrados
  const [produtosCadastrados, setProdutosCadastrados] = useState([
    { codigo: 'PROD001', descricao: 'Notebook Dell Inspiron 15' },
    { codigo: 'PROD002', descricao: 'Mouse Logitech MX Master 3' },
    { codigo: 'PROD003', descricao: 'Teclado Mecânico Keychron K2' },
    { codigo: 'PROD004', descricao: 'Monitor LG UltraWide 29"' },
    { codigo: 'PROD005', descricao: 'Webcam Logitech C920' },
  ]);

  const [servicosCadastrados, setServicosCadastrados] = useState([
    { codigo: 'SERV001', descricao: 'Consultoria em TI' },
    { codigo: 'SERV002', descricao: 'Manutenção de Equipamentos' },
    { codigo: 'SERV003', descricao: 'Desenvolvimento de Software' },
    { codigo: 'SERV004', descricao: 'Suporte Técnico' },
    { codigo: 'SERV005', descricao: 'Treinamento Corporativo' },
  ]);

  // Estados para busca de produtos/serviços
  const [buscaProduto, setBuscaProduto] = useState('');
  const [mostrarDropdownProduto, setMostrarDropdownProduto] = useState(false);
  const [buscaServico, setBuscaServico] = useState('');
  const [mostrarDropdownServico, setMostrarDropdownServico] = useState(false);

  // Estados para modal de cadastro
  const [mostrarModalCadastro, setMostrarModalCadastro] = useState(false);
  const [tipoCadastro, setTipoCadastro] = useState<'produto' | 'servico'>('produto');
  const [novoCodigo, setNovoCodigo] = useState('');
  const [novaDescricao, setNovaDescricao] = useState('');

  // Estado para novo registro
  const [novoRegistro, setNovoRegistro] = useState({
    tipo: 'produto',
    // Identificação
    dataVenda: '',
    numeroContrato: '',
    numeroNota: '',
    idVenda: '',
    numeroOS: '',
    numeroNFSe: '',
    // Cliente
    nomeCliente: '',
    cpfCnpjCliente: '',
    // Participante
    cpfParticipante: '',
    nomeParticipante: '',
    // Produto/Serviço
    codigoProduto: '',
    descricaoProduto: '',
    quantidade: '',
    valorUnitario: '',
    valorTotal: '',
    codigoServico: '',
    descricaoServico: '',
    valorServico: '',
    // Pagamento
    dataVencimento: '',
    dataPagamento: '',
    // Informações
    observacoes: ''
  });

  // Função para calcular valor total (apenas para produtos)
  const calcularValorTotal = () => {
    if (novoRegistro.tipo === 'produto') {
      const quantidade = parseFloat(novoRegistro.quantidade) || 0;
      const valorUnitario = parseFloat(novoRegistro.valorUnitario) || 0;
      const total = quantidade * valorUnitario;
      setNovoRegistro({ ...novoRegistro, valorTotal: total.toFixed(2) });
    }
  };

  // Mock data
  const [registrosProdutos, setRegistrosProdutos] = useState<RegistroProduto[]>([
    {
      id: '1',
      dataVenda: '2024-01-15',
      numeroContrato: 'CTR-2024-001',
      numeroNFe: '12345',
      idVenda: 'VND-001',
      clienteNome: 'João Silva Ltda',
      clienteCpfCnpj: '12.345.678/0001-90',
      participanteCpf: '123.456.789-01',
      participanteNome: 'Ana Silva',
      codigoProduto: 'PROD-001',
      descricaoProduto: 'Notebook Dell Inspiron 15',
      quantidade: 2,
      valorUnitario: 3500.00,
      valorTotal: 7000.00,
      dataVencimento: '2024-02-15',
      dataPagamento: '2024-02-10',
      observacoes: 'Venda realizada com desconto especial',
      dataCriacao: new Date('2024-01-15'),
      status: 'Aprovado'
    },
    {
      id: '2',
      dataVenda: '2024-01-18',
      numeroContrato: 'CTR-2024-002',
      numeroNFe: '12346',
      idVenda: 'VND-002',
      clienteNome: 'Maria Santos',
      clienteCpfCnpj: '987.654.321-00',
      participanteCpf: '987.654.321-02',
      participanteNome: 'Carlos Eduardo Lima',
      codigoProduto: 'PROD-002',
      descricaoProduto: 'Mouse Logitech MX Master 3',
      quantidade: 5,
      valorUnitario: 450.00,
      valorTotal: 2250.00,
      dataVencimento: '2024-02-18',
      dataPagamento: '',
      observacoes: '',
      dataCriacao: new Date('2024-01-18'),
      status: 'Pendente'
    }
  ]);

  const [registrosServicos, setRegistrosServicos] = useState<RegistroServico[]>([
    {
      id: '1',
      dataServico: '2024-01-16',
      numeroContrato: 'CTR-SRV-2024-001',
      numeroOS: 'OS-001',
      numeroNFSe: 'NFSE-12345',
      clienteNome: 'Empresa ABC Ltda',
      clienteCpfCnpj: '11.222.333/0001-44',
      participanteCpf: '456.789.123-03',
      participanteNome: 'Mariana Santos',
      codigoServico: 'SRV-001',
      tipoDescricaoServico: 'Consultoria em TI - Implementação de Sistema',
      valorServico: 15000.00,
      dataVencimento: '2024-02-16',
      dataPagamento: '2024-02-14',
      observacoes: 'Projeto concluído com sucesso',
      dataCriacao: new Date('2024-01-16'),
      status: 'Aprovado'
    },
    {
      id: '2',
      dataServico: '2024-01-19',
      numeroContrato: 'CTR-SRV-2024-002',
      numeroOS: 'OS-002',
      numeroNFSe: 'NFSE-12346',
      clienteNome: 'Pedro Oliveira',
      clienteCpfCnpj: '555.666.777-88',
      participanteCpf: '321.654.987-05',
      participanteNome: 'Juliana Rodrigues',
      codigoServico: 'SRV-002',
      tipoDescricaoServico: 'Manutenção Preventiva de Equipamentos',
      valorServico: 3500.00,
      dataVencimento: '2024-02-19',
      dataPagamento: '',
      observacoes: '',
      dataCriacao: new Date('2024-01-19'),
      status: 'Pendente'
    }
  ]);

  const [formProduto, setFormProduto] = useState<Partial<RegistroProduto>>({
    dataVenda: '',
    numeroContrato: '',
    numeroNFe: '',
    idVenda: '',
    clienteNome: '',
    clienteCpfCnpj: '',
    participanteCpf: '',
    participanteNome: '',
    codigoProduto: '',
    descricaoProduto: '',
    quantidade: 1,
    valorUnitario: 0,
    valorTotal: 0,
    dataVencimento: '',
    dataPagamento: '',
    observacoes: ''
  });

  const [formServico, setFormServico] = useState<Partial<RegistroServico>>({
    dataServico: '',
    numeroContrato: '',
    numeroOS: '',
    numeroNFSe: '',
    clienteNome: '',
    clienteCpfCnpj: '',
    participanteCpf: '',
    participanteNome: '',
    codigoServico: '',
    tipoDescricaoServico: '',
    valorServico: 0,
    dataVencimento: '',
    dataPagamento: '',
    observacoes: ''
  });

  const [csvFile, setCsvFile] = useState<File | null>(null);
  const [apiConfig, setApiConfig] = useState({
    endpoint: '',
    apiKey: '',
    metodo: 'GET',
    headers: '',
    body: ''
  });

  // Filtrar produtos
  const produtosFiltrados = produtosCadastrados.filter(
    (p) =>
      p.codigo.toLowerCase().includes(buscaProduto.toLowerCase()) ||
      p.descricao.toLowerCase().includes(buscaProduto.toLowerCase())
  );

  // Filtrar serviços
  const servicosFiltrados = servicosCadastrados.filter(
    (s) =>
      s.codigo.toLowerCase().includes(buscaServico.toLowerCase()) ||
      s.descricao.toLowerCase().includes(buscaServico.toLowerCase())
  );

  // Selecionar produto
  const selecionarProduto = (produto: { codigo: string; descricao: string }) => {
    setNovoRegistro({
      ...novoRegistro,
      codigoProduto: produto.codigo,
      descricaoProduto: produto.descricao,
    });
    setBuscaProduto('');
    setMostrarDropdownProduto(false);
  };

  // Selecionar serviço
  const selecionarServico = (servico: { codigo: string; descricao: string }) => {
    setNovoRegistro({
      ...novoRegistro,
      codigoServico: servico.codigo,
      descricaoServico: servico.descricao,
    });
    setBuscaServico('');
    setMostrarDropdownServico(false);
  };

  // Abrir modal de cadastro
  const abrirModalCadastro = (tipo: 'produto' | 'servico') => {
    setTipoCadastro(tipo);
    setNovoCodigo('');
    setNovaDescricao('');
    setMostrarModalCadastro(true);
  };

  // Cadastrar novo produto/serviço
  const handleCadastrarItem = (e: React.FormEvent) => {
    e.preventDefault();

    if (!novoCodigo.trim() || !novaDescricao.trim()) {
      alert('Por favor, preencha todos os campos');
      return;
    }

    if (tipoCadastro === 'produto') {
      // Verificar se código já existe
      if (produtosCadastrados.some((p) => p.codigo === novoCodigo)) {
        alert('Código de produto já cadastrado');
        return;
      }

      const novoProduto = { codigo: novoCodigo, descricao: novaDescricao };
      setProdutosCadastrados([...produtosCadastrados, novoProduto]);
      
      // Selecionar automaticamente o produto cadastrado
      setNovoRegistro({
        ...novoRegistro,
        codigoProduto: novoProduto.codigo,
        descricaoProduto: novoProduto.descricao,
      });
    } else {
      // Verificar se código já existe
      if (servicosCadastrados.some((s) => s.codigo === novoCodigo)) {
        alert('Código de serviço já cadastrado');
        return;
      }

      const novoServico = { codigo: novoCodigo, descricao: novaDescricao };
      setServicosCadastrados([...servicosCadastrados, novoServico]);
      
      // Selecionar automaticamente o serviço cadastrado
      setNovoRegistro({
        ...novoRegistro,
        codigoServico: novoServico.codigo,
        descricaoServico: novoServico.descricao,
      });
    }

    setMostrarModalCadastro(false);
    alert(`${tipoCadastro === 'produto' ? 'Produto' : 'Serviço'} cadastrado com sucesso!`);
  };

  // Função para submeter o novo registro
  const handleSubmitRegistro = (e: React.FormEvent) => {
    e.preventDefault();
    
    // Validação básica
    if (!novoRegistro.nomeCliente || !novoRegistro.cpfCnpjCliente || 
        !novoRegistro.nomeParticipante || !novoRegistro.cpfParticipante ||
        !novoRegistro.nomeProdutoServico || !novoRegistro.dataVenda) {
      alert('Por favor, preencha todos os campos obrigatórios.');
      return;
    }

    console.log('Cadastrando registro:', novoRegistro);
    alert('Registro cadastrado com sucesso!');
    
    // Resetar formulário
    setNovoRegistro({
      tipo: 'produto',
      dataVenda: '',
      numeroContrato: '',
      numeroNota: '',
      idVenda: '',
      numeroOS: '',
      numeroNFSe: '',
      nomeCliente: '',
      cpfCnpjCliente: '',
      cpfParticipante: '',
      nomeParticipante: '',
      codigoProduto: '',
      descricao: '',
      quantidade: '',
      valorUnitario: '',
      valorTotal: '',
      codigoServico: '',
      tipoServico: '',
      valorServico: '',
      dataVencimento: '',
      dataPagamento: '',
      observacoes: ''
    });
    
    setShowFormularioManual(false);
  };

  // Funções de ação dos botões
  const handleVerDetalhes = (registro: any) => {
    setRegistroSelecionado(registro);
    setShowModalDetalhes(true);
  };

  const handleEditar = (registro: any) => {
    setRegistroSelecionado(registro);
    setModoEdicao(true);
    
    if (registro.tipo === 'Produto') {
      setTipoRegistro('produto');
      setFormProduto({
        dataVenda: registro.dataVenda,
        numeroContrato: registro.numeroContrato,
        numeroNFe: registro.numeroNFe,
        idVenda: registro.idVenda,
        clienteNome: registro.clienteNome,
        clienteCpfCnpj: registro.clienteCpfCnpj,
        participanteCpf: registro.participanteCpf,
        participanteNome: registro.participanteNome,
        codigoProduto: registro.codigoProduto,
        descricaoProduto: registro.descricaoProduto,
        quantidade: registro.quantidade,
        valorUnitario: registro.valorUnitario,
        valorTotal: registro.valorTotal,
        dataVencimento: registro.dataVencimento,
        dataPagamento: registro.dataPagamento,
        observacoes: registro.observacoes
      });
    } else {
      setTipoRegistro('servico');
      setFormServico({
        dataServico: registro.dataServico,
        numeroContrato: registro.numeroContrato,
        numeroOS: registro.numeroOS,
        numeroNFSe: registro.numeroNFSe,
        clienteNome: registro.clienteNome,
        clienteCpfCnpj: registro.clienteCpfCnpj,
        participanteCpf: registro.participanteCpf,
        participanteNome: registro.participanteNome,
        codigoServico: registro.codigoServico,
        tipoDescricaoServico: registro.tipoDescricaoServico,
        valorServico: registro.valorServico,
        dataVencimento: registro.dataVencimento,
        dataPagamento: registro.dataPagamento,
        observacoes: registro.observacoes
      });
    }
    
    setShowModalRegistro(true);
  };

  const handleExcluir = (registro: any) => {
    setRegistroSelecionado(registro);
    setShowModalExcluir(true);
  };

  const confirmarExclusao = () => {
    if (!registroSelecionado) return;

    if (registroSelecionado.tipo === 'Produto') {
      setRegistrosProdutos(registrosProdutos.filter(r => r.id !== registroSelecionado.id));
    } else {
      setRegistrosServicos(registrosServicos.filter(r => r.id !== registroSelecionado.id));
    }

    setShowModalExcluir(false);
    setRegistroSelecionado(null);
    alert('Registro excluído com sucesso!');
  };

  const handleCalcularTotal = () => {
    const total = (formProduto.quantidade || 0) * (formProduto.valorUnitario || 0);
    setFormProduto({ ...formProduto, valorTotal: total });
  };

  const handleSubmitProduto = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (modoEdicao && registroSelecionado) {
      // Atualizar produto existente
      setRegistrosProdutos(registrosProdutos.map(r => 
        r.id === registroSelecionado.id 
          ? { ...r, ...formProduto } 
          : r
      ));
      alert('Produto atualizado com sucesso!');
    } else {
      // Criar novo produto
      console.log('Cadastrando produto:', formProduto);
      alert('Produto cadastrado com sucesso!');
    }
    
    setShowModalRegistro(false);
    setModoEdicao(false);
    setRegistroSelecionado(null);
  };

  const handleSubmitServico = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (modoEdicao && registroSelecionado) {
      // Atualizar serviço existente
      setRegistrosServicos(registrosServicos.map(r => 
        r.id === registroSelecionado.id 
          ? { ...r, ...formServico } 
          : r
      ));
      alert('Serviço atualizado com sucesso!');
    } else {
      // Criar novo serviço
      console.log('Cadastrando serviço:', formServico);
      alert('Serviço cadastrado com sucesso!');
    }
    
    setShowModalRegistro(false);
    setModoEdicao(false);
    setRegistroSelecionado(null);
  };

  const handleImportCSV = () => {
    if (!csvFile) {
      alert('Selecione um arquivo CSV para importar.');
      return;
    }
    console.log('Importando CSV:', csvFile);
    setShowModalImportacao(false);
    alert('Arquivo CSV importado com sucesso!');
  };

  const handleConfigAPI = () => {
    if (!apiConfig.endpoint || !apiConfig.apiKey) {
      alert('Preencha o endpoint e a chave da API.');
      return;
    }
    console.log('Configurando API:', apiConfig);
    setShowModalAPI(false);
    alert('Integração API configurada com sucesso!');
  };

  const getStatusColor = (status: string) => {
    const colors = {
      'Pendente': 'bg-yellow-100 text-yellow-800',
      'Aprovado': 'bg-green-100 text-green-800',
      'Rejeitado': 'bg-red-100 text-red-800'
    };
    return colors[status as keyof typeof colors] || 'bg-gray-100 text-gray-800';
  };

  const todosRegistros = [
    ...registrosProdutos.map(r => ({ ...r, tipo: 'Produto' as const })),
    ...registrosServicos.map(r => ({ ...r, tipo: 'Serviço' as const }))
  ].sort((a, b) => b.dataCriacao.getTime() - a.dataCriacao.getTime());

  const registrosFiltrados = todosRegistros.filter(registro => {
    const matchesSearch = 
      ('participanteNome' in registro && registro.participanteNome.toLowerCase().includes(searchTerm.toLowerCase())) ||
      ('clienteNome' in registro && registro.clienteNome.toLowerCase().includes(searchTerm.toLowerCase())) ||
      ('numeroContrato' in registro && registro.numeroContrato.toLowerCase().includes(searchTerm.toLowerCase()));
    
    const matchesStatus = filtroStatus === 'todos' || registro.status === filtroStatus;
    const matchesTipo = filtroTipo === 'todos' || registro.tipo === filtroTipo;
    
    return matchesSearch && matchesStatus && matchesTipo;
  });

  const totalProdutos = registrosProdutos.length;
  const totalServicos = registrosServicos.length;
  const totalAprovados = todosRegistros.filter(r => r.status === 'Aprovado').length;
  const totalPendentes = todosRegistros.filter(r => r.status === 'Pendente').length;

  return (
    <Layout>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <button
              onClick={() => navigate('/admin/incentivo/participantes')}
              className="text-blue-600 hover:text-blue-700 mb-2 flex items-center space-x-1 cursor-pointer"
            >
              <i className="ri-arrow-left-line"></i>
              <span className="text-sm">Voltar para Participantes</span>
            </button>
            <h1 className="text-2xl font-bold text-gray-900">Gestão de Performance</h1>
            <p className="text-gray-600 mt-1">Registre e gerencie vendas de produtos e serviços dos participantes</p>
          </div>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">Total de Produtos</p>
                <p className="text-2xl font-bold text-gray-900 mt-2">{totalProdutos}</p>
              </div>
              <div className="w-12 h-12 rounded-lg bg-blue-600 flex items-center justify-center">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-shopping-cart-line text-white text-xl"></i>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">Total de Serviços</p>
                <p className="text-2xl font-bold text-gray-900 mt-2">{totalServicos}</p>
              </div>
              <div className="w-12 h-12 rounded-lg bg-purple-600 flex items-center justify-center">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-tools-line text-white text-xl"></i>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">Aprovados</p>
                <p className="text-2xl font-bold text-gray-900 mt-2">{totalAprovados}</p>
              </div>
              <div className="w-12 h-12 rounded-lg bg-green-600 flex items-center justify-center">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-checkbox-circle-line text-white text-xl"></i>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-gray-600">Pendentes</p>
                <p className="text-2xl font-bold text-gray-900 mt-2">{totalPendentes}</p>
              </div>
              <div className="w-12 h-12 rounded-lg bg-yellow-600 flex items-center justify-center">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-time-line text-white text-xl"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Métodos de Importação */}
        {!metodoImportacao && (
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Métodos de Importação</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {/* Cadastro Manual */}
              <button
                onClick={() => setMetodoImportacao('manual')}
                className="p-6 border-2 border-gray-200 rounded-lg hover:border-blue-500 hover:bg-blue-50 transition-all cursor-pointer text-left"
              >
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-edit-line text-blue-600 text-xl"></i>
                  </div>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Cadastro Manual</h4>
                <p className="text-sm text-gray-600">Cadastre vendas individualmente com controle total</p>
              </button>

              {/* Importação CSV */}
              <button
                onClick={() => setMetodoImportacao('csv')}
                className="p-6 border-2 border-gray-200 rounded-lg hover:border-green-500 hover:bg-green-50 transition-all cursor-pointer text-left"
              >
                <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-file-excel-line text-green-600 text-xl"></i>
                  </div>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Importação CSV</h4>
                <p className="text-sm text-gray-600">Importe múltiplos registros de uma vez</p>
              </button>

              {/* Integração API */}
              <button
                onClick={() => setMetodoImportacao('api')}
                className="p-6 border-2 border-gray-200 rounded-lg hover:border-purple-500 hover:bg-purple-50 transition-all cursor-pointer text-left"
              >
                <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-code-s-slash-line text-purple-600 text-xl"></i>
                  </div>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Integração API</h4>
                <p className="text-sm text-gray-600">Configure integração automática via API</p>
              </button>
            </div>
          </div>
        )}

        {/* Cadastro Manual */}
        {metodoImportacao === 'manual' && !showFormularioManual && (
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-lg font-semibold text-gray-900">Cadastro Manual</h3>
              <button
                onClick={() => setMetodoImportacao(null)}
                className="text-gray-600 hover:text-gray-900 cursor-pointer flex items-center space-x-2"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-left-line"></i>
                </div>
                <span>Voltar</span>
              </button>
            </div>
            <div className="text-center py-12">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-edit-line text-blue-600 text-2xl"></i>
                </div>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Cadastro Manual de Registros</h3>
              <p className="text-gray-600 mb-6">Cadastre vendas de produtos ou serviços individualmente com controle total sobre os dados</p>
              <button
                onClick={() => {
                  setModoEdicao(false);
                  setRegistroSelecionado(null);
                  setShowFormularioManual(true);
                }}
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg flex items-center space-x-2 transition-colors cursor-pointer whitespace-nowrap mx-auto"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-add-line"></i>
                </div>
                <span>Cadastrar Novo Registro</span>
              </button>
            </div>
          </div>
        )}

        {/* Formulário de Cadastro Manual */}
        {metodoImportacao === 'manual' && showFormularioManual && (
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-lg font-semibold text-gray-900">
                {modoEdicao ? 'Editar Registro' : 'Novo Registro'}
              </h3>
              <button
                onClick={() => {
                  setShowFormularioManual(false);
                  setModoEdicao(false);
                  setRegistroSelecionado(null);
                }}
                className="text-gray-600 hover:text-gray-900 cursor-pointer flex items-center space-x-2"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-left-line"></i>
                </div>
                <span>Voltar</span>
              </button>
            </div>

            <form onSubmit={handleSubmitRegistro} className="space-y-6">
              {/* Tipo de Registro */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Tipo de Registro <span className="text-red-500">*</span>
                </label>
                <div className="grid grid-cols-2 gap-4">
                  <button
                    type="button"
                    onClick={() => setNovoRegistro({ ...novoRegistro, tipo: 'produto' })}
                    className={`p-4 border-2 rounded-lg cursor-pointer transition-all ${
                      novoRegistro.tipo === 'produto'
                        ? 'border-teal-500 bg-teal-50'
                        : 'border-gray-200 hover:border-gray-300'
                    }`}
                  >
                    <div className="flex items-center space-x-3">
                      <div className="w-5 h-5 flex items-center justify-center">
                        <i className="ri-shopping-bag-line text-xl"></i>
                      </div>
                      <span className="font-medium">Venda de Produtos</span>
                    </div>
                  </button>
                  <button
                    type="button"
                    onClick={() => setNovoRegistro({ ...novoRegistro, tipo: 'servico' })}
                    className={`p-4 border-2 rounded-lg cursor-pointer transition-all ${
                      novoRegistro.tipo === 'servico'
                        ? 'border-teal-500 bg-teal-50'
                        : 'border-gray-200 hover:border-gray-300'
                    }`}
                  >
                    <div className="flex items-center space-x-3">
                      <div className="w-5 h-5 flex items-center justify-center">
                        <i className="ri-tools-line text-xl"></i>
                      </div>
                      <span className="font-medium">Venda de Serviços</span>
                    </div>
                  </button>
                </div>
              </div>

              {/* Seção A - Identificação */}
              <div className="bg-gray-50 p-4 rounded-lg">
                <h4 className="font-semibold text-gray-900 mb-4">
                  {novoRegistro.tipo === 'produto' ? 'Identificação da Venda' : 'Identificação do Serviço'}
                </h4>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      {novoRegistro.tipo === 'produto' ? 'Data da Venda' : 'Data do Serviço'} <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="date"
                      value={novoRegistro.dataVenda}
                      onChange={(e) => setNovoRegistro({ ...novoRegistro, dataVenda: e.target.value })}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Número de Contrato
                    </label>
                    <input
                      type="text"
                      value={novoRegistro.numeroContrato}
                      onChange={(e) => setNovoRegistro({ ...novoRegistro, numeroContrato: e.target.value })}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                      placeholder="Ex: CTR-2024-001"
                    />
                  </div>
                  {novoRegistro.tipo === 'produto' ? (
                    <>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Número da Nota Fiscal (NFe)
                        </label>
                        <input
                          type="text"
                          value={novoRegistro.numeroNota}
                          onChange={(e) => setNovoRegistro({ ...novoRegistro, numeroNota: e.target.value })}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                          placeholder="Ex: 123456"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          ID da Venda
                        </label>
                        <input
                          type="text"
                          value={novoRegistro.idVenda}
                          onChange={(e) => setNovoRegistro({ ...novoRegistro, idVenda: e.target.value })}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                          placeholder="Ex: VND-2024-001"
                        />
                      </div>
                    </>
                  ) : (
                    <>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Número da OS
                        </label>
                        <input
                          type="text"
                          value={novoRegistro.numeroOS}
                          onChange={(e) => setNovoRegistro({ ...novoRegistro, numeroOS: e.target.value })}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                          placeholder="Ex: OS-2024-001"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Número da NFS-e
                        </label>
                        <input
                          type="text"
                          value={novoRegistro.numeroNFSe}
                          onChange={(e) => setNovoRegistro({ ...novoRegistro, numeroNFSe: e.target.value })}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                          placeholder="Ex: 123456"
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>

              {/* Seção B - Cliente */}
              <div className="bg-gray-50 p-4 rounded-lg">
                <h4 className="font-semibold text-gray-900 mb-4">Cliente</h4>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Nome / Razão Social <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      value={novoRegistro.nomeCliente}
                      onChange={(e) => setNovoRegistro({ ...novoRegistro, nomeCliente: e.target.value })}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                      placeholder="Nome completo ou razão social"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      CPF / CNPJ <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      value={novoRegistro.cpfCnpjCliente}
                      onChange={(e) => setNovoRegistro({ ...novoRegistro, cpfCnpjCliente: e.target.value })}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                      placeholder="000.000.000-00 ou 00.000.000/0000-00"
                      required
                    />
                  </div>
                </div>
              </div>

              {/* Seção C - Participante */}
              <div className="bg-gray-50 p-4 rounded-lg">
                <h4 className="font-semibold text-gray-900 mb-4">Participante</h4>
                
                {/* Campo de Busca de Participante */}
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Buscar Participante <span className="text-red-500">*</span>
                  </label>
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-search-line text-gray-400"></i>
                      </div>
                    </div>
                    <input
                      type="text"
                      value={buscaParticipante}
                      onChange={(e) => handleBuscaParticipante(e.target.value)}
                      onFocus={() => {
                        if (buscaParticipante.trim() !== '') {
                          setShowDropdownParticipante(true);
                        }
                      }}
                      className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                      placeholder="Digite o nome, CPF, email ou departamento do participante"
                    />
                    
                    {/* Dropdown de Resultados */}
                    {showDropdownParticipante && participantesFiltrados.length > 0 && (
                      <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto">
                        {participantesFiltrados.map((participante) => (
                          <button
                            key={participante.id}
                            type="button"
                            onClick={() => handleSelecionarParticipante(participante)}
                            className="w-full px-4 py-3 text-left hover:bg-gray-50 border-b border-gray-100 last:border-b-0 cursor-pointer transition-colors"
                          >
                            <div className="flex items-center justify-between">
                              <div className="flex-1">
                                <div className="text-sm font-medium text-gray-900">{participante.nome}</div>
                                <div className="text-xs text-gray-500 mt-1">
                                  CPF: {participante.cpf} • {participante.departamento} • {participante.cargo}
                                </div>
                                <div className="text-xs text-gray-400 mt-0.5">{participante.email}</div>
                              </div>
                              <div className="w-5 h-5 flex items-center justify-center text-teal-600">
                                <i className="ri-arrow-right-s-line"></i>
                              </div>
                            </div>
                          </button>
                        ))}
                      </div>
                    )}

                    {/* Mensagem quando não encontrar participantes */}
                    {showDropdownParticipante && participantesFiltrados.length === 0 && buscaParticipante.trim() !== '' && (
                      <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg p-4">
                        <div className="text-center">
                          <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-2">
                            <div className="w-6 h-6 flex items-center justify-center">
                              <i className="ri-user-search-line text-gray-400"></i>
                            </div>
                          </div>
                          <p className="text-sm text-gray-600">Nenhum participante encontrado</p>
                          <p className="text-xs text-gray-500 mt-1">Tente buscar por nome, CPF, email ou departamento</p>
                        </div>
                      </div>
                    )}
                  </div>
                  <p className="text-xs text-gray-500 mt-1">
                    <i className="ri-information-line"></i> Busque e selecione o participante da lista para preencher automaticamente os campos
                  </p>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    CPF do Participante <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    value={novoRegistro.cpfParticipante}
                    onChange={(e) => setNovoRegistro({ ...novoRegistro, cpfParticipante: e.target.value })}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent bg-gray-100"
                    placeholder="000.000.000-00"
                    readOnly
                    required
                  />
                </div>
              </div>

              {/* Seção D - Produto/Serviço */}
              <div className="bg-gray-50 p-4 rounded-lg">
                <h4 className="font-semibold text-gray-900 mb-4">
                  {novoRegistro.tipo === 'produto' ? 'Produto Vendido' : 'Serviço Executado'}
                </h4>
                {novoRegistro.tipo === 'produto' ? (
                  <div className="space-y-4">
                    {/* Código do Produto com Combobox */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Código do Produto <span className="text-red-500">*</span>
                      </label>
                      <div className="flex space-x-2">
                        <div className="flex-1 relative">
                          <input
                            type="text"
                            value={novoRegistro.codigoProduto || buscaProduto}
                            onChange={(e) => {
                              const valor = e.target.value;
                              setBuscaProduto(valor);
                              setNovoRegistro({ ...novoRegistro, codigoProduto: valor });
                              setMostrarDropdownProduto(valor.length > 0);
                            }}
                            onFocus={() => {
                              if (buscaProduto.length > 0 || novoRegistro.codigoProduto.length > 0) {
                                setMostrarDropdownProduto(true);
                              }
                            }}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                            placeholder="Digite para buscar ou selecionar"
                            required
                          />
                          
                          {/* Dropdown de Produtos */}
                          {mostrarDropdownProduto && produtosFiltrados.length > 0 && (
                            <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-48 overflow-y-auto">
                              {produtosFiltrados.map((produto) => (
                                <button
                                  key={produto.codigo}
                                  type="button"
                                  onClick={() => selecionarProduto(produto)}
                                  className="w-full px-4 py-2 text-left hover:bg-gray-50 border-b border-gray-100 last:border-b-0 cursor-pointer transition-colors"
                                >
                                  <div className="text-sm font-medium text-gray-900">{produto.codigo}</div>
                                  <div className="text-xs text-gray-500">{produto.descricao}</div>
                                </button>
                              ))}
                            </div>
                          )}
                        </div>
                        <button
                          type="button"
                          onClick={() => abrirModalCadastro('produto')}
                          className="px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer flex items-center space-x-1"
                        >
                          <i className="ri-add-line"></i>
                          <span>Novo</span>
                        </button>
                      </div>
                    </div>

                    {/* Descrição do Produto */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Descrição <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        value={novoRegistro.descricaoProduto}
                        onChange={(e) => setNovoRegistro({ ...novoRegistro, descricaoProduto: e.target.value })}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent bg-gray-100"
                        placeholder="Descrição do produto"
                        readOnly
                        required
                      />
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Quantidade <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="number"
                          value={novoRegistro.quantidade}
                          onChange={(e) => setNovoRegistro({ ...novoRegistro, quantidade: e.target.value })}
                          onBlur={calcularValorTotal}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                          placeholder="0"
                          min="0"
                          step="1"
                          required
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Valor Unitário <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="number"
                          value={novoRegistro.valorUnitario}
                          onChange={(e) => setNovoRegistro({ ...novoRegistro, valorUnitario: e.target.value })}
                          onBlur={calcularValorTotal}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                          placeholder="0,00"
                          min="0"
                          step="0.01"
                          required
                        />
                      </div>
                    </div>
                    
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Valor Total <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="number"
                        value={novoRegistro.valorTotal}
                        onChange={(e) => setNovoRegistro({ ...novoRegistro, valorTotal: e.target.value })}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-100 focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                        placeholder="0,00"
                        min="0"
                        step="0.01"
                        readOnly
                        required
                      />
                    </div>
                  </div>
                ) : (
                  <div className="space-y-4">
                    {/* Código do Serviço com Combobox */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Código do Serviço <span className="text-red-500">*</span>
                      </label>
                      <div className="flex space-x-2">
                        <div className="flex-1 relative">
                          <input
                            type="text"
                            value={novoRegistro.codigoServico || buscaServico}
                            onChange={(e) => {
                              const valor = e.target.value;
                              setBuscaServico(valor);
                              setNovoRegistro({ ...novoRegistro, codigoServico: valor });
                              setMostrarDropdownServico(valor.length > 0);
                            }}
                            onFocus={() => {
                              if (buscaServico.length > 0 || novoRegistro.codigoServico.length > 0) {
                                setMostrarDropdownServico(true);
                              }
                            }}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                            placeholder="Digite para buscar ou selecionar"
                            required
                          />
                          
                          {/* Dropdown de Serviços */}
                          {mostrarDropdownServico && servicosFiltrados.length > 0 && (
                            <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-48 overflow-y-auto">
                              {servicosFiltrados.map((servico) => (
                                <button
                                  key={servico.codigo}
                                  type="button"
                                  onClick={() => selecionarServico(servico)}
                                  className="w-full px-4 py-2 text-left hover:bg-gray-50 border-b border-gray-100 last:border-b-0 cursor-pointer transition-colors"
                                >
                                  <div className="text-sm font-medium text-gray-900">{servico.codigo}</div>
                                  <div className="text-xs text-gray-500">{servico.descricao}</div>
                                </button>
                              ))}
                            </div>
                          )}
                        </div>
                        <button
                          type="button"
                          onClick={() => abrirModalCadastro('servico')}
                          className="px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer flex items-center space-x-1"
                        >
                          <i className="ri-add-line"></i>
                          <span>Novo</span>
                        </button>
                      </div>
                    </div>

                    {/* Descrição do Serviço */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Tipo/Descrição do Serviço <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        value={novoRegistro.descricaoServico}
                        onChange={(e) => setNovoRegistro({ ...novoRegistro, descricaoServico: e.target.value })}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent bg-gray-100"
                        placeholder="Descrição do serviço"
                        readOnly
                        required
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Valor do Serviço <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="number"
                        value={novoRegistro.valorServico}
                        onChange={(e) => setNovoRegistro({ ...novoRegistro, valorServico: e.target.value })}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                        placeholder="0,00"
                        min="0"
                        step="0.01"
                        required
                      />
                    </div>
                  </div>
                )}
              </div>

              {/* Seção E - Pagamento */}
              <div className="bg-gray-50 p-4 rounded-lg">
                <h4 className="font-semibold text-gray-900 mb-4">Pagamento</h4>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Data do Vencimento
                    </label>
                    <input
                      type="date"
                      value={novoRegistro.dataVencimento}
                      onChange={(e) => setNovoRegistro({ ...novoRegistro, dataVencimento: e.target.value })}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Data do Pagamento
                    </label>
                    <input
                      type="date"
                      value={novoRegistro.dataPagamento}
                      onChange={(e) => setNovoRegistro({ ...novoRegistro, dataPagamento: e.target.value })}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                    />
                  </div>
                </div>
              </div>

              {/* Seção F - Informações */}
              <div className="bg-gray-50 p-4 rounded-lg">
                <h4 className="font-semibold text-gray-900 mb-4">Informações</h4>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Observações
                  </label>
                  <textarea
                    value={novoRegistro.observacoes}
                    onChange={(e) => setNovoRegistro({ ...novoRegistro, observacoes: e.target.value })}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent"
                    rows={4}
                    placeholder="Informações adicionais sobre a venda/serviço"
                    maxLength={500}
                  />
                  <p className="text-xs text-gray-500 mt-1">
                    {novoRegistro.observacoes.length}/500 caracteres
                  </p>
                </div>
              </div>

              {/* Botões de Ação */}
              <div className="flex justify-end space-x-3 pt-4 border-t border-gray-200">
                <button
                  type="button"
                  onClick={() => {
                    setShowFormularioManual(false);
                    setNovoRegistro({
                      tipo: 'produto',
                      dataVenda: '',
                      numeroContrato: '',
                      numeroNota: '',
                      idVenda: '',
                      numeroOS: '',
                      numeroNFSe: '',
                      nomeCliente: '',
                      cpfCnpjCliente: '',
                      cpfParticipante: '',
                      nomeParticipante: '',
                      codigoProduto: '',
                      descricao: '',
                      quantidade: '',
                      valorUnitario: '',
                      valorTotal: '',
                      codigoServico: '',
                      tipoServico: '',
                      valorServico: '',
                      dataVencimento: '',
                      dataPagamento: '',
                      observacoes: ''
                    });
                  }}
                  className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 cursor-pointer whitespace-nowrap"
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  className="px-6 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 cursor-pointer whitespace-nowrap"
                >
                  Cadastrar Registro
                </button>
              </div>
            </form>
          </div>
        )}

        {/* Importação CSV */}
        {metodoImportacao === 'csv' && (
          <div className="space-y-6">
            {/* Instruções e Template */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <h3 className="text-lg font-semibold text-gray-900 mb-4">Importação via CSV</h3>
                  <div className="space-y-4">
                    <div className="bg-purple-50 border border-purple-200 rounded-lg p-4">
                      <div className="flex items-start space-x-3">
                        <div className="w-6 h-6 rounded-full bg-purple-500 flex items-center justify-center flex-shrink-0 mt-0.5">
                          <div className="w-3 h-3 flex items-center justify-center">
                            <i className="ri-information-line text-white text-xs"></i>
                          </div>
                        </div>
                        <div>
                          <h4 className="text-sm font-semibold text-purple-900 mb-2">Instruções para o arquivo CSV</h4>
                          <ul className="text-sm text-purple-800 space-y-1">
                            <li>• O arquivo deve conter as colunas necessárias para produtos ou serviços</li>
                            <li>• Use vírgula (,) como separador de campos</li>
                            <li>• A primeira linha deve conter os cabeçalhos das colunas</li>
                            <li>• Máximo de 1000 registros por arquivo</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    {/* Tipo de Registro */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-3">Tipo de Registro</label>
                      <div className="grid grid-cols-2 gap-4">
                        <button
                          onClick={() => setTipoRegistro('produto')}
                          className={`border-2 rounded-lg p-3 transition-all cursor-pointer ${
                            tipoRegistro === 'produto'
                              ? 'border-blue-500 bg-blue-50'
                              : 'border-gray-200 hover:border-blue-300'
                          }`}
                        >
                          <div className="flex items-center space-x-2">
                            <i className="ri-shopping-cart-line text-lg"></i>
                            <span className="font-medium">Produtos</span>
                          </div>
                        </button>
                        <button
                          onClick={() => setTipoRegistro('servico')}
                          className={`border-2 rounded-lg p-3 transition-all cursor-pointer ${
                            tipoRegistro === 'servico'
                              ? 'border-purple-500 bg-purple-50'
                              : 'border-gray-200 hover:border-purple-300'
                          }`}
                        >
                          <div className="flex items-center space-x-2">
                            <i className="ri-tools-line text-lg"></i>
                            <span className="font-medium">Serviços</span>
                          </div>
                        </button>
                      </div>
                    </div>

                    <div className="flex items-center space-x-4">
                      <button
                        onClick={() => alert('Baixando template CSV...')}
                        className="bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded-lg flex items-center space-x-2 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        <div className="w-4 h-4 flex items-center justify-center">
                          <i className="ri-download-line"></i>
                        </div>
                        <span>Baixar Template CSV de {tipoRegistro === 'produto' ? 'Produtos' : 'Serviços'}</span>
                      </button>
                      <span className="text-sm text-gray-600">Use este template como base para seu arquivo</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Upload Area */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
              <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center">
                {!csvFile ? (
                  <>
                    <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                      <div className="w-8 h-8 flex items-center justify-center">
                        <i className="ri-upload-cloud-line text-gray-400 text-2xl"></i>
                      </div>
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">Faça upload do seu arquivo CSV</h3>
                    <p className="text-sm text-gray-600 mb-4">Arraste e solte o arquivo aqui ou clique para selecionar</p>
                    <input
                      type="file"
                      accept=".csv"
                      onChange={(e) => {
                        if (e.target.files && e.target.files[0]) {
                          setCsvFile(e.target.files[0]);
                        }
                      }}
                      className="hidden"
                      id="csvFileUpload"
                    />
                    <label
                      htmlFor="csvFileUpload"
                      className="inline-flex items-center px-6 py-3 bg-purple-600 hover:bg-purple-700 text-white font-medium rounded-lg cursor-pointer transition-colors"
                    >
                      <div className="w-4 h-4 flex items-center justify-center mr-2">
                        <i className="ri-folder-open-line"></i>
                      </div>
                      Selecionar Arquivo CSV
                    </label>
                    <p className="text-xs text-gray-500 mt-2">Formatos aceitos: .csv (máx. 10MB)</p>
                  </>
                ) : (
                  <div className="space-y-4">
                    <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto">
                      <div className="w-8 h-8 flex items-center justify-center">
                        <i className="ri-file-excel-line text-green-600 text-2xl"></i>
                      </div>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900">{csvFile.name}</h3>
                      <p className="text-sm text-gray-600">Tamanho: {(csvFile.size / 1024).toFixed(2)} KB</p>
                    </div>
                    <div className="flex items-center justify-center space-x-3">
                      <button
                        onClick={() => setCsvFile(null)}
                        className="px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                      >
                        Remover Arquivo
                      </button>
                      <button
                        onClick={handleImportCSV}
                        className="px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                      >
                        Processar Importação
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Conteúdo do Método API */}
        {metodoImportacao === 'api' && (
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Configuração de Integração API</h3>
            
            <div className="space-y-6">
              {/* Tipo de Registro */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-3">Tipo de Registro</label>
                <div className="grid grid-cols-2 gap-4">
                  <button
                    onClick={() => setTipoRegistro('produto')}
                    className={`border-2 rounded-lg p-3 transition-all cursor-pointer ${
                      tipoRegistro === 'produto'
                        ? 'border-blue-500 bg-blue-50'
                        : 'border-gray-200 hover:border-blue-300'
                    }`}
                  >
                    <div className="flex items-center space-x-2">
                      <i className="ri-shopping-cart-line text-lg"></i>
                      <span className="font-medium">Produtos</span>
                    </div>
                  </button>
                  <button
                    onClick={() => setTipoRegistro('servico')}
                    className={`border-2 rounded-lg p-3 transition-all cursor-pointer ${
                      tipoRegistro === 'servico'
                        ? 'border-purple-500 bg-purple-50'
                        : 'border-gray-200 hover:border-purple-300'
                    }`}
                  >
                    <div className="flex items-center space-x-2">
                      <i className="ri-tools-line text-lg"></i>
                      <span className="font-medium">Serviços</span>
                    </div>
                  </button>
                </div>
              </div>

              {/* Configuração da API */}
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Endpoint da API *</label>
                  <input
                    type="url"
                    required
                    value={apiConfig.endpoint}
                    onChange={(e) => setApiConfig({...apiConfig, endpoint: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 text-sm"
                    placeholder="https://api.exemplo.com/vendas"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Chave da API *</label>
                  <input
                    type="password"
                    required
                    value={apiConfig.apiKey}
                    onChange={(e) => setApiConfig({...apiConfig, apiKey: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 text-sm"
                    placeholder="Sua chave de API"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Método HTTP</label>
                  <select
                    value={apiConfig.metodo}
                    onChange={(e) => setApiConfig({...apiConfig, metodo: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 text-sm pr-8"
                  >
                    <option value="GET">GET</option>
                    <option value="POST">POST</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Headers Personalizados (JSON)</label>
                  <textarea
                    value={apiConfig.headers}
                    onChange={(e) => setApiConfig({...apiConfig, headers: e.target.value})}
                    rows={3}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 text-sm font-mono"
                    placeholder='{"Content-Type": "application/json"}'
                  />
                </div>

                {apiConfig.metodo === 'POST' && (
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Body da Requisição (JSON)</label>
                    <textarea
                      value={apiConfig.body}
                      onChange={(e) => setApiConfig({...apiConfig, body: e.target.value})}
                      rows={4}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 text-sm font-mono"
                      placeholder='{"filtro": "ultimos_30_dias"}'
                    />
                  </div>
                )}
              </div>

              {/* Informação */}
              <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                <div className="flex items-start space-x-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-information-line text-green-600"></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-green-900 mb-1">Integração Automática</h4>
                    <p className="text-xs text-green-800">
                      Após configurar a API, os dados serão sincronizados automaticamente a cada hora. 
                      Você pode testar a conexão antes de salvar.
                    </p>
                  </div>
                </div>
              </div>

              {/* Botões */}
              <div className="flex items-center justify-end space-x-3 pt-6 border-t border-gray-200">
                <button
                  onClick={() => alert('Testando conexão...')}
                  className="px-6 py-2 text-green-700 bg-green-100 hover:bg-green-200 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                >
                  Testar Conexão
                </button>
                <button
                  onClick={handleConfigAPI}
                  className="px-6 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                >
                  Salvar Configuração
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Filtros */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-4 md:space-y-0">
            <div className="flex flex-col md:flex-row md:items-center space-y-4 md:space-y-0 md:space-x-4">
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-search-line text-gray-400"></i>
                  </div>
                </div>
                <input
                  type="text"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                  placeholder="Buscar por participante, cliente ou contrato..."
                />
              </div>

              <select
                value={filtroTipo}
                onChange={(e) => setFiltroTipo(e.target.value)}
                className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm pr-8"
              >
                <option value="todos">Todos os Tipos</option>
                <option value="Produto">Produtos</option>
                <option value="Serviço">Serviços</option>
              </select>

              <select
                value={filtroStatus}
                onChange={(e) => setFiltroStatus(e.target.value)}
                className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm pr-8"
              >
                <option value="todos">Todos os Status</option>
                <option value="Pendente">Pendente</option>
                <option value="Aprovado">Aprovado</option>
                <option value="Rejeitado">Rejeitado</option>
              </select>
            </div>

            <div className="flex items-center space-x-2">
              <span className="text-sm text-gray-600">
                {registrosFiltrados.length} de {todosRegistros.length} registros
              </span>
            </div>
          </div>
        </div>

        {/* Tabela de Registros */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Data
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Tipo
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Participante
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Cliente
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Descrição
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Valor
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Status
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Ações
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {registrosFiltrados.map((registro) => (
                  <tr key={registro.id} className="hover:bg-gray-50">
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-900">
                        {'dataVenda' in registro ? registro.dataVenda : registro.dataServico}
                      </div>
                      <div className="text-xs text-gray-500">
                        {registro.numeroContrato}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className={`inline-flex px-3 py-1 text-xs font-semibold rounded-full whitespace-nowrap ${
                        registro.tipo === 'Produto' 
                          ? 'bg-blue-100 text-blue-800' 
                          : 'bg-purple-100 text-purple-800'
                      }`}>
                        {registro.tipo}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm font-medium text-gray-900">{registro.participanteNome}</div>
                      <div className="text-xs text-gray-500">{registro.participanteCpf}</div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm text-gray-900">{registro.clienteNome}</div>
                      <div className="text-xs text-gray-500">{registro.clienteCpfCnpj}</div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="text-sm text-gray-900 max-w-xs truncate">
                        {'descricaoProduto' in registro ? registro.descricaoProduto : registro.tipoDescricaoServico}
                      </div>
                      <div className="text-xs text-gray-500">
                        {'codigoProduto' in registro ? registro.codigoProduto : registro.codigoServico}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm font-semibold text-gray-900">
                        R$ {'valorTotal' in registro 
                          ? registro.valorTotal.toLocaleString('pt-BR', { minimumFractionDigits: 2 })
                          : registro.valorServico.toLocaleString('pt-BR', { minimumFractionDigits: 2 })
                        }
                      </div>
                      {'quantidade' in registro && (
                        <div className="text-xs text-gray-500">
                          {registro.quantidade}x R$ {registro.valorUnitario.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                        </div>
                      )}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full whitespace-nowrap ${getStatusColor(registro.status)}`}>
                        {registro.status}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                      <div className="flex items-center justify-end space-x-2">
                        <button
                          onClick={() => handleVerDetalhes(registro)}
                          className="w-8 h-8 flex items-center justify-center text-blue-600 hover:bg-blue-50 rounded-lg transition-colors cursor-pointer"
                          title="Ver Detalhes"
                        >
                          <i className="ri-eye-line"></i>
                        </button>
                        <button
                          onClick={() => handleEditar(registro)}
                          className="w-8 h-8 flex items-center justify-center text-green-600 hover:bg-green-50 rounded-lg transition-colors cursor-pointer"
                          title="Editar"
                        >
                          <i className="ri-edit-line"></i>
                        </button>
                        <button
                          onClick={() => handleExcluir(registro)}
                          className="w-8 h-8 flex items-center justify-center text-red-600 hover:bg-red-50 rounded-lg transition-colors cursor-pointer"
                          title="Excluir"
                        >
                          <i className="ri-delete-bin-line"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {registrosFiltrados.length === 0 && (
            <div className="text-center py-12">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-file-list-line text-gray-400 text-2xl"></i>
                </div>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Nenhum registro encontrado</h3>
              <p className="text-gray-600 mb-4">Comece adicionando registros de produtos ou serviços</p>
            </div>
          )}
        </div>

        {/* Modal de Ver Detalhes */}
        {showModalDetalhes && registroSelecionado && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg w-full max-w-3xl max-h-[90vh] overflow-y-auto">
              <div className="flex items-center justify-between p-6 border-b border-gray-200">
                <div>
                  <h3 className="text-xl font-semibold text-gray-900">Detalhes do Registro</h3>
                  <p className="text-sm text-gray-600 mt-1">
                    {registroSelecionado.tipo} - {registroSelecionado.numeroContrato}
                  </p>
                </div>
                <button
                  onClick={() => setShowModalDetalhes(false)}
                  className="text-gray-400 hover:text-gray-600 cursor-pointer"
                >
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-close-line text-xl"></i>
                  </div>
                </button>
              </div>

              <div className="p-6 space-y-6">
                {/* Status */}
                <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                  <span className="text-sm font-medium text-gray-700">Status do Registro</span>
                  <span className={`inline-flex px-3 py-1 text-xs font-semibold rounded-full whitespace-nowrap ${getStatusColor(registroSelecionado.status)}`}>
                    {registroSelecionado.status}
                  </span>
                </div>

                {/* Identificação */}
                <div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-4">Identificação</h4>
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-600 mb-1">Data</label>
                      <p className="text-sm text-gray-900">
                        {'dataVenda' in registroSelecionado ? registroSelecionado.dataVenda : registroSelecionado.dataServico}
                      </p>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-600 mb-1">Número de Contrato</label>
                      <p className="text-sm text-gray-900">{registroSelecionado.numeroContrato || '-'}</p>
                    </div>
                    {'numeroNFe' in registroSelecionado && (
                      <div>
                        <label className="block text-sm font-medium text-gray-600 mb-1">Número da NFe</label>
                        <p className="text-sm text-gray-900">{registroSelecionado.numeroNFe || '-'}</p>
                      </div>
                    )}
                    {'numeroOS' in registroSelecionado && (
                      <div>
                        <label className="block text-sm font-medium text-gray-600 mb-1">Número da OS</label>
                        <p className="text-sm text-gray-900">{registroSelecionado.numeroOS || '-'}</p>
                      </div>
                    )}
                    {'numeroNFSe' in registroSelecionado && (
                      <div>
                        <label className="block text-sm font-medium text-gray-600 mb-1">Número da NFS-e</label>
                        <p className="text-sm text-gray-900">{registroSelecionado.numeroNFSe || '-'}</p>
                      </div>
                    )}
                  </div>
                </div>

                {/* Cliente */}
                <div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-4">Cliente</h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-600 mb-1">Nome / Razão Social</label>
                      <p className="text-sm text-gray-900">{registroSelecionado.clienteNome}</p>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-600 mb-1">CPF / CNPJ</label>
                      <p className="text-sm text-gray-900">{registroSelecionado.clienteCpfCnpj}</p>
                    </div>
                  </div>
                </div>

                {/* Participante */}
                <div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-4">Participante</h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-600 mb-1">Nome</label>
                      <p className="text-sm text-gray-900">{registroSelecionado.participanteNome}</p>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-600 mb-1">CPF</label>
                      <p className="text-sm text-gray-900">{registroSelecionado.participanteCpf}</p>
                    </div>
                  </div>
                </div>

                {/* Produto/Serviço */}
                <div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-4">
                    {registroSelecionado.tipo === 'Produto' ? 'Produto Vendido' : 'Serviço Executado'}
                  </h4>
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-600 mb-1">Código</label>
                      <p className="text-sm text-gray-900">
                        {'codigoProduto' in registroSelecionado ? registroSelecionado.codigoProduto : registroSelecionado.codigoServico}
                      </p>
                    </div>
                    <div className="col-span-2">
                      <label className="block text-sm font-medium text-gray-600 mb-1">Descrição</label>
                      <p className="text-sm text-gray-900">
                        {'descricaoProduto' in registroSelecionado ? registroSelecionado.descricaoProduto : registroSelecionado.tipoDescricaoServico}
                      </p>
                    </div>
                    {'quantidade' in registroSelecionado && (
                      <>
                        <div>
                          <label className="block text-sm font-medium text-gray-600 mb-1">Quantidade</label>
                          <p className="text-sm text-gray-900">{registroSelecionado.quantidade}</p>
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-600 mb-1">Valor Unitário</label>
                          <p className="text-sm text-gray-900">
                            R$ {registroSelecionado.valorUnitario.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                          </p>
                        </div>
                      </>
                    )}
                    <div>
                      <label className="block text-sm font-medium text-gray-600 mb-1">Valor Total</label>
                      <p className="text-lg font-bold text-gray-900">
                        R$ {'valorTotal' in registroSelecionado 
                          ? registroSelecionado.valorTotal.toLocaleString('pt-BR', { minimumFractionDigits: 2 })
                          : registroSelecionado.valorServico.toLocaleString('pt-BR', { minimumFractionDigits: 2 })
                        }
                      </p>
                    </div>
                  </div>
                </div>

                {/* Pagamento */}
                <div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-4">Pagamento</h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-600 mb-1">Data do Vencimento</label>
                      <p className="text-sm text-gray-900">{registroSelecionado.dataVencimento || '-'}</p>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-600 mb-1">Data do Pagamento</label>
                      <p className="text-sm text-gray-900">{registroSelecionado.dataPagamento || 'Não pago'}</p>
                    </div>
                  </div>
                </div>

                {/* Observações */}
                {registroSelecionado.observacoes && (
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-4">Observações</h4>
                    <p className="text-sm text-gray-700 bg-gray-50 p-4 rounded-lg">
                      {registroSelecionado.observacoes}
                    </p>
                  </div>
                )}

                {/* Botões */}
                <div className="flex items-center justify-end space-x-3 pt-6 border-t border-gray-200">
                  <button
                    onClick={() => setShowModalDetalhes(false)}
                    className="px-6 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Fechar
                  </button>
                  <button
                    onClick={() => {
                      setShowModalDetalhes(false);
                      handleEditar(registroSelecionado);
                    }}
                    className="px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors cursor-pointer whitespace-nowrap flex items-center space-x-2"
                  >
                    <i className="ri-edit-line"></i>
                    <span>Editar</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Modal de Confirmação de Exclusão */}
        {showModalExcluir && registroSelecionado && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg w-full max-w-md">
              <div className="p-6">
                <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-4">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-alert-line text-red-600 text-2xl"></i>
                  </div>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 text-center mb-2">Confirmar Exclusão</h3>
                <p className="text-gray-600 text-center mb-6">
                  Tem certeza que deseja excluir este registro? Esta ação não pode ser desfeita.
                </p>
                
                <div className="bg-gray-50 rounded-lg p-4 mb-6">
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-sm font-medium text-gray-600">Tipo:</span>
                    <span className="text-sm text-gray-900">{registroSelecionado.tipo}</span>
                  </div>
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-sm font-medium text-gray-600">Participante:</span>
                    <span className="text-sm text-gray-900">{registroSelecionado.participanteNome}</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-sm font-medium text-gray-600">Contrato:</span>
                    <span className="text-sm text-gray-900">{registroSelecionado.numeroContrato}</span>
                  </div>
                </div>

                <div className="flex items-center space-x-3">
                  <button
                    onClick={() => {
                      setShowModalExcluir(false);
                      setRegistroSelecionado(null);
                    }}
                    className="flex-1 px-6 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Cancelar
                  </button>
                  <button
                    onClick={confirmarExclusao}
                    className="flex-1 px-6 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Excluir
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Modal de Cadastro Manual */}
        {showModalRegistro && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg w-full max-w-4xl max-h-[90vh] overflow-y-auto">
              <div className="flex items-center justify-between p-6 border-b border-gray-200">
                <div>
                  <h3 className="text-xl font-semibold text-gray-900">Novo Registro de Performance</h3>
                  <p className="text-sm text-gray-600 mt-1">Cadastre vendas de produtos ou serviços</p>
                </div>
                <button
                  onClick={() => setShowModalRegistro(false)}
                  className="text-gray-400 hover:text-gray-600 cursor-pointer"
                >
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-close-line text-xl"></i>
                  </div>
                </button>
              </div>

              <div className="p-6">
                {/* Seleção de Tipo */}
                <div className="mb-6">
                  <label className="block text-sm font-medium text-gray-700 mb-3">Tipo de Registro</label>
                  <div className="grid grid-cols-2 gap-4">
                    <button
                      onClick={() => setTipoRegistro('produto')}
                      className={`border-2 rounded-lg p-4 transition-all cursor-pointer ${
                        tipoRegistro === 'produto'
                          ? 'border-blue-500 bg-blue-50'
                          : 'border-gray-200 hover:border-blue-300'
                      }`}
                    >
                      <div className="flex items-center space-x-3">
                        <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${
                          tipoRegistro === 'produto' ? 'bg-blue-500' : 'bg-gray-200'
                        }`}>
                          <div className="w-5 h-5 flex items-center justify-center">
                            <i className={`ri-shopping-cart-line text-xl ${
                              tipoRegistro === 'produto' ? 'text-white' : 'text-gray-600'
                            }`}></i>
                          </div>
                        </div>
                        <div className="text-left">
                          <div className="font-semibold text-gray-900">Produto</div>
                          <div className="text-xs text-gray-600">Venda de produtos físicos</div>
                        </div>
                      </div>
                    </button>

                    <button
                      onClick={() => setTipoRegistro('servico')}
                      className={`border-2 rounded-lg p-4 transition-all cursor-pointer ${
                        tipoRegistro === 'servico'
                          ? 'border-purple-500 bg-purple-50'
                          : 'border-gray-200 hover:border-purple-300'
                      }`}
                    >
                      <div className="flex items-center space-x-3">
                        <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${
                          tipoRegistro === 'servico' ? 'bg-purple-500' : 'bg-gray-200'
                        }`}>
                          <div className="w-5 h-5 flex items-center justify-center">
                            <i className={`ri-tools-line text-xl ${
                              tipoRegistro === 'servico' ? 'text-white' : 'text-gray-600'
                            }`}></i>
                          </div>
                        </div>
                        <div className="text-left">
                          <div className="font-semibold text-gray-900">Serviço</div>
                          <div className="text-xs text-gray-600">Prestação de serviços</div>
                        </div>
                      </div>
                    </button>
                  </div>
                </div>

                {/* Formulário de Produto */}
                {tipoRegistro === 'produto' && (
                  <form onSubmit={handleSubmitProduto} className="space-y-6">
                    {/* Identificação da Venda */}
                    <div>
                      <h4 className="text-lg font-semibold text-gray-900 mb-4">Identificação da Venda</h4>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">Data da Venda *</label>
                          <input
                            type="date"
                            required
                            value={formProduto.dataVenda}
                            onChange={(e) => setFormProduto({...formProduto, dataVenda: e.target.value})}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                          />
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">Número de Contrato</label>
                          <input
                            type="text"
                            value={formProduto.numeroContrato}
                            onChange={(e) => setFormProduto({...formProduto, numeroContrato: e.target.value})}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                            placeholder="CTR-2024-001"
                          />
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">Número da NFe</label>
                          <input
                            type="text"
                            value={formProduto.numeroNFe}
                            onChange={(e) => setFormProduto({...formProduto, numeroNFe: e.target.value})}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                            placeholder="12345"
                          />
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">ID da Venda</label>
                          <input
                            type="text"
                            value={formProduto.idVenda}
                            onChange={(e) => setFormProduto({...formProduto, idVenda: e.target.value})}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                            placeholder="VND-001"
                          />
                        </div>
                      </div>
                    </div>

                    {/* Cliente */}
                    <div>
                      <h4 className="text-lg font-semibold text-gray-900 mb-4">Cliente</h4>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">Nome / Razão Social *</label>
                          <input
                            type="text"
                            required
                            value={formProduto.clienteNome}
                            onChange={(e) => setFormProduto({...formProduto, clienteNome: e.target.value})}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                            placeholder="Nome do cliente"
                          />
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">CPF / CNPJ *</label>
                          <input
                            type="text"
                            required
                            value={formProduto.clienteCpfCnpj}
                            onChange={(e) => setFormProduto({...formProduto, clienteCpfCnpj: e.target.value})}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                            placeholder="000.000.000-00"
                          />
                        </div>
                      </div>
                    </div>

                    {/* Participante */}
                    <div>
                      <h4 className="text-lg font-semibold text-gray-900 mb-4">Participante</h4>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">CPF do Participante *</label>
                          <input
                            type="text"
                            required
                            value={formProduto.participanteCpf}
                            onChange={(e) => setFormProduto({...formProduto, participanteCpf: e.target.value})}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                            placeholder="000.000.000-00"
                          />
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">Nome do Participante *</label>
                          <input
                            type="text"
                            required
                            value={formProduto.participanteNome}
                            onChange={(e) => setFormProduto({...formProduto, participanteNome: e.target.value})}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                            placeholder="Nome do participante"
                          />
                        </div>
                      </div>
                    </div>

                    {/* Produto Vendido */}
                    <div>
                      <h4 className="text-lg font-semibold text-gray-900 mb-4">Produto Vendido</h4>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">Código do Produto *</label>
                          <input
                            type="text"
                            required
                            value={formProduto.codigoProduto}
                            onChange={(e) => setFormProduto({...formProduto, codigoProduto: e.target.value})}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                            placeholder="PROD-001"
                          />
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">Descrição *</label>
                          <input
                            type="text"
                            required
                            value={formProduto.descricaoProduto}
                            onChange={(e) => setFormProduto({...formProduto, descricaoProduto: e.target.value})}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                            placeholder="Descrição do produto"
                          />
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">Quantidade *</label>
                          <input
                            type="number"
                            required
                            min="1"
                            value={formProduto.quantidade}
                            onChange={(e) => setFormProduto({...formProduto, quantidade: parseInt(e.target.value)})}
                            onBlur={handleCalcularTotal}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                          />
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">Valor Unitário *</label>
                          <input
                            type="number"
                            required
                            min="0"
                            step="0.01"
                            value={formProduto.valorUnitario}
                            onChange={(e) => setFormProduto({...formProduto, valorUnitario: parseFloat(e.target.value)})}
                            onBlur={handleCalcularTotal}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                            placeholder="0,00"
                          />
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">Valor Total</label>
                          <input
                            type="number"
                            readOnly
                            value={formProduto.valorTotal}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 text-sm"
                          />
                        </div>
                      </div>
                    </div>

                    {/* Pagamento */}
                    <div>
                      <h4 className="text-lg font-semibold text-gray-900 mb-4">Pagamento</h4>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">Data do Vencimento</label>
                          <input
                            type="date"
                            value={formProduto.dataVencimento}
                            onChange={(e) => setFormProduto({...formProduto, dataVencimento: e.target.value})}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                          />
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">Data do Pagamento</label>
                          <input
                            type="date"
                            value={formProduto.dataPagamento}
                            onChange={(e) => setFormProduto({...formProduto, dataPagamento: e.target.value})}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                          />
                        </div>
                      </div>
                    </div>

                    {/* Informações */}
                    <div>
                      <h4 className="text-lg font-semibold text-gray-900 mb-4">Informações</h4>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Observações</label>
                        <textarea
                          value={formProduto.observacoes}
                          onChange={(e) => setFormProduto({...formProduto, observacoes: e.target.value})}
                          rows={3}
                          maxLength={500}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                          placeholder="Informações adicionais sobre a venda..."
                        />
                        <p className="text-xs text-gray-500 mt-1">Máximo 500 caracteres</p>
                      </div>
                    </div>

                    {/* Botões */}
                    <div className="flex items-center justify-end space-x-3 pt-6 border-t border-gray-200">
                      <button
                        type="button"
                        onClick={() => setShowModalRegistro(false)}
                        className="px-6 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                      >
                        Cancelar
                      </button>
                      <button
                        type="submit"
                        className="px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                      >
                        Cadastrar Produto
                      </button>
                    </div>
                  </form>
                )}

                {/* Formulário de Serviço */}
                {tipoRegistro === 'servico' && (
                  <form onSubmit={handleSubmitServico} className="space-y-6">
                    {/* Identificação do Serviço */}
                    <div>
                      <h4 className="text-lg font-semibold text-gray-900 mb-4">Identificação do Serviço</h4>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">Data do Serviço *</label>
                          <input
                            type="date"
                            required
                            value={formServico.dataServico}
                            onChange={(e) => setFormServico({...formServico, dataServico: e.target.value})}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                          />
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">Número de Contrato</label>
                          <input
                            type="text"
                            value={formServico.numeroContrato}
                            onChange={(e) => setFormServico({...formServico, numeroContrato: e.target.value})}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                            placeholder="CTR-SRV-2024-001"
                          />
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">Número da OS</label>
                          <input
                            type="text"
                            value={formServico.numeroOS}
                            onChange={(e) => setFormServico({...formServico, numeroOS: e.target.value})}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                            placeholder="OS-001"
                          />
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">Número da NFS-e</label>
                          <input
                            type="text"
                            value={formServico.numeroNFSe}
                            onChange={(e) => setFormServico({...formServico, numeroNFSe: e.target.value})}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                            placeholder="NFSE-12345"
                          />
                        </div>
                      </div>
                    </div>

                    {/* Cliente */}
                    <div>
                      <h4 className="text-lg font-semibold text-gray-900 mb-4">Cliente</h4>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">Nome / Razão Social *</label>
                          <input
                            type="text"
                            required
                            value={formServico.clienteNome}
                            onChange={(e) => setFormServico({...formServico, clienteNome: e.target.value})}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                            placeholder="Nome do cliente"
                          />
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">CPF / CNPJ *</label>
                          <input
                            type="text"
                            required
                            value={formServico.clienteCpfCnpj}
                            onChange={(e) => setFormServico({...formServico, clienteCpfCnpj: e.target.value})}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                            placeholder="000.000.000-00"
                          />
                        </div>
                      </div>
                    </div>

                    {/* Participante */}
                    <div>
                      <h4 className="text-lg font-semibold text-gray-900 mb-4">Participante</h4>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">CPF do Participante *</label>
                          <input
                            type="text"
                            required
                            value={formServico.participanteCpf}
                            onChange={(e) => setFormServico({...formServico, participanteCpf: e.target.value})}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                            placeholder="000.000.000-00"
                          />
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">Nome do Participante *</label>
                          <input
                            type="text"
                            required
                            value={formServico.participanteNome}
                            onChange={(e) => setFormServico({...formServico, participanteNome: e.target.value})}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                            placeholder="Nome do participante"
                          />
                        </div>
                      </div>
                    </div>

                    {/* Serviço Executado */}
                    <div>
                      <h4 className="text-lg font-semibold text-gray-900 mb-4">Serviço Executado</h4>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">Código do Serviço *</label>
                          <input
                            type="text"
                            required
                            value={formServico.codigoServico}
                            onChange={(e) => setFormServico({...formServico, codigoServico: e.target.value})}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                            placeholder="SRV-001"
                          />
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">Tipo/Descrição do Serviço *</label>
                          <input
                            type="text"
                            required
                            value={formServico.tipoDescricaoServico}
                            onChange={(e) => setFormServico({...formServico, tipoDescricaoServico: e.target.value})}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                            placeholder="Descrição do serviço"
                          />
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">Valor do Serviço *</label>
                          <input
                            type="number"
                            required
                            min="0"
                            step="0.01"
                            value={formServico.valorServico}
                            onChange={(e) => setFormServico({...formServico, valorServico: parseFloat(e.target.value)})}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                            placeholder="0,00"
                          />
                        </div>
                      </div>
                    </div>

                    {/* Pagamento */}
                    <div>
                      <h4 className="text-lg font-semibold text-gray-900 mb-4">Pagamento</h4>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">Data do Vencimento</label>
                          <input
                            type="date"
                            value={formServico.dataVencimento}
                            onChange={(e) => setFormServico({...formServico, dataVencimento: e.target.value})}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                          />
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-2">Data do Pagamento</label>
                          <input
                            type="date"
                            value={formServico.dataPagamento}
                            onChange={(e) => setFormServico({...formServico, dataPagamento: e.target.value})}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                          />
                        </div>
                      </div>
                    </div>

                    {/* Informações */}
                    <div>
                      <h4 className="text-lg font-semibold text-gray-900 mb-4">Informações</h4>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">Observações</label>
                        <textarea
                          value={formServico.observacoes}
                          onChange={(e) => setFormServico({...formServico, observacoes: e.target.value})}
                          rows={3}
                          maxLength={500}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                          placeholder="Informações adicionais sobre o serviço..."
                        />
                        <p className="text-xs text-gray-500 mt-1">Máximo 500 caracteres</p>
                      </div>
                    </div>

                    {/* Botões */}
                    <div className="flex items-center justify-end space-x-3 pt-6 border-t border-gray-200">
                      <button
                        type="button"
                        onClick={() => setShowModalRegistro(false)}
                        className="px-6 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                      >
                        Cancelar
                      </button>
                      <button
                        type="submit"
                        className="px-6 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                      >
                        Cadastrar Serviço
                      </button>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Modal de Importação CSV */}
        {showModalImportacao && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg w-full max-w-2xl">
              <div className="flex items-center justify-between p-6 border-b border-gray-200">
                <div>
                  <h3 className="text-xl font-semibold text-gray-900">Importação via CSV</h3>
                  <p className="text-sm text-gray-600 mt-1">Importe múltiplos registros de uma vez</p>
                </div>
                <button
                  onClick={() => setShowModalImportacao(false)}
                  className="text-gray-400 hover:text-gray-600 cursor-pointer"
                >
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-close-line text-xl"></i>
                  </div>
                </button>
              </div>

              <div className="p-6 space-y-6">
                {/* Tipo de Registro */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-3">Tipo de Registro</label>
                  <div className="grid grid-cols-2 gap-4">
                    <button
                      onClick={() => setTipoRegistro('produto')}
                      className={`border-2 rounded-lg p-3 transition-all cursor-pointer ${
                        tipoRegistro === 'produto'
                          ? 'border-blue-500 bg-blue-50'
                          : 'border-gray-200 hover:border-blue-300'
                      }`}
                    >
                      <div className="flex items-center space-x-2">
                        <i className="ri-shopping-cart-line text-lg"></i>
                        <span className="font-medium">Produtos</span>
                      </div>
                    </button>
                    <button
                      onClick={() => setTipoRegistro('servico')}
                      className={`border-2 rounded-lg p-3 transition-all cursor-pointer ${
                        tipoRegistro === 'servico'
                          ? 'border-purple-500 bg-purple-50'
                          : 'border-gray-200 hover:border-purple-300'
                      }`}
                    >
                      <div className="flex items-center space-x-2">
                        <i className="ri-tools-line text-lg"></i>
                        <span className="font-medium">Serviços</span>
                      </div>
                    </button>
                  </div>
                </div>

                {/* Upload de Arquivo */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Arquivo CSV</label>
                  <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center">
                    <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                      <div className="w-6 h-6 flex items-center justify-center">
                        <i className="ri-file-excel-line text-gray-400 text-xl"></i>
                      </div>
                    </div>
                    <p className="text-sm text-gray-600 mb-2">Arraste e solte o arquivo CSV aqui ou clique para selecionar</p>
                    <p className="text-xs text-gray-500 mb-4">Formato aceito: .csv (máx. 10MB)</p>
                    <input
                      type="file"
                      accept=".csv"
                      className="hidden"
                      id="csvFile"
                      onChange={(e) => {
                        if (e.target.files && e.target.files[0]) {
                          setCsvFile(e.target.files[0]);
                        }
                      }}
                    />
                    <label
                      htmlFor="csvFile"
                      className="inline-flex items-center px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white text-sm font-medium rounded-lg cursor-pointer transition-colors"
                    >
                      <div className="w-4 h-4 flex items-center justify-center mr-2">
                        <i className="ri-folder-open-line"></i>
                      </div>
                      Selecionar Arquivo
                    </label>
                  </div>
                  {csvFile && (
                    <div className="mt-3 flex items-center justify-between bg-gray-50 p-3 rounded">
                      <div className="flex items-center space-x-2">
                        <i className="ri-file-excel-line text-green-600"></i>
                        <span className="text-sm text-gray-700">{csvFile.name}</span>
                      </div>
                      <button
                        onClick={() => setCsvFile(null)}
                        className="text-red-600 hover:text-red-800 cursor-pointer"
                      >
                        <i className="ri-close-line"></i>
                      </button>
                    </div>
                  )}
                </div>

                {/* Modelo CSV */}
                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                  <div className="flex items-start space-x-3">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-information-line text-blue-600"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-blue-900 mb-2">Modelo de CSV</h4>
                      <p className="text-xs text-blue-800 mb-2">
                        Baixe o modelo de CSV para garantir que seu arquivo está no formato correto:
                      </p>
                      <button className="text-xs text-blue-600 hover:text-blue-700 font-medium flex items-center space-x-1 cursor-pointer">
                        <i className="ri-download-line"></i>
                        <span>Baixar modelo de {tipoRegistro === 'produto' ? 'Produtos' : 'Serviços'}</span>
                      </button>
                    </div>
                  </div>
                </div>

                {/* Botões */}
                <div className="flex items-center justify-end space-x-3 pt-6 border-t border-gray-200">
                  <button
                    onClick={() => setShowModalImportacao(false)}
                    className="px-6 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Cancelar
                  </button>
                  <button
                    onClick={handleImportCSV}
                    disabled={!csvFile}
                    className="px-6 py-2 bg-purple-600 hover:bg-purple-700 disabled:bg-gray-300 disabled:cursor-not-allowed text-white rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Importar CSV
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Modal de Integração API */}
        {showModalAPI && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg w-full max-w-2xl">
              <div className="flex items-center justify-between p-6 border-b border-gray-200">
                <div>
                  <h3 className="text-xl font-semibold text-gray-900">Integração via API</h3>
                  <p className="text-sm text-gray-600 mt-1">Configure a integração automática com seus sistemas</p>
                </div>
                <button
                  onClick={() => setShowModalAPI(false)}
                  className="text-gray-400 hover:text-gray-600 cursor-pointer"
                >
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-close-line text-xl"></i>
                  </div>
                </button>
              </div>

              <div className="p-6 space-y-6">
                {/* Tipo de Registro */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-3">Tipo de Registro</label>
                  <div className="grid grid-cols-2 gap-4">
                    <button
                      onClick={() => setTipoRegistro('produto')}
                      className={`border-2 rounded-lg p-3 transition-all cursor-pointer ${
                        tipoRegistro === 'produto'
                          ? 'border-blue-500 bg-blue-50'
                          : 'border-gray-200 hover:border-blue-300'
                      }`}
                    >
                      <div className="flex items-center space-x-2">
                        <i className="ri-shopping-cart-line text-lg"></i>
                        <span className="font-medium">Produtos</span>
                      </div>
                    </button>
                    <button
                      onClick={() => setTipoRegistro('servico')}
                      className={`border-2 rounded-lg p-3 transition-all cursor-pointer ${
                        tipoRegistro === 'servico'
                          ? 'border-purple-500 bg-purple-50'
                          : 'border-gray-200 hover:border-purple-300'
                      }`}
                    >
                      <div className="flex items-center space-x-2">
                        <i className="ri-tools-line text-lg"></i>
                        <span className="font-medium">Serviços</span>
                      </div>
                    </button>
                  </div>
                </div>

                {/* Configuração da API */}
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Endpoint da API *</label>
                    <input
                      type="url"
                      required
                      value={apiConfig.endpoint}
                      onChange={(e) => setApiConfig({...apiConfig, endpoint: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 text-sm"
                      placeholder="https://api.exemplo.com/vendas"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Chave da API *</label>
                    <input
                      type="password"
                      required
                      value={apiConfig.apiKey}
                      onChange={(e) => setApiConfig({...apiConfig, apiKey: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 text-sm"
                      placeholder="Sua chave de API"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Método HTTP</label>
                    <select
                      value={apiConfig.metodo}
                      onChange={(e) => setApiConfig({...apiConfig, metodo: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 text-sm pr-8"
                    >
                      <option value="GET">GET</option>
                      <option value="POST">POST</option>
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Headers Personalizados (JSON)</label>
                    <textarea
                      value={apiConfig.headers}
                      onChange={(e) => setApiConfig({...apiConfig, headers: e.target.value})}
                      rows={3}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 text-sm font-mono"
                      placeholder='{"Content-Type": "application/json"}'
                    />
                  </div>

                  {apiConfig.metodo === 'POST' && (
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Body da Requisição (JSON)</label>
                      <textarea
                        value={apiConfig.body}
                        onChange={(e) => setApiConfig({...apiConfig, body: e.target.value})}
                        rows={4}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 text-sm font-mono"
                        placeholder='{"filtro": "ultimos_30_dias"}'
                      />
                    </div>
                  )}
                </div>

                {/* Informação */}
                <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                  <div className="flex items-start space-x-3">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-information-line text-green-600"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-green-900 mb-1">Integração Automática</h4>
                      <p className="text-xs text-green-800">
                        Após configurar a API, os dados serão sincronizados automaticamente a cada hora. 
                        Você pode testar a conexão antes de salvar.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Botões */}
                <div className="flex items-center justify-end space-x-3 pt-6 border-t border-gray-200">
                  <button
                    onClick={() => setShowModalAPI(false)}
                    className="px-6 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Cancelar
                  </button>
                  <button
                    onClick={() => alert('Testando conexão...')}
                    className="px-6 py-2 text-green-700 bg-green-100 hover:bg-green-200 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Testar Conexão
                  </button>
                  <button
                    onClick={handleConfigAPI}
                    className="px-6 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Salvar Configuração
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Modal de Cadastro de Produto/Serviço */}
        {mostrarModalCadastro && (
          <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
              <div className="p-6 border-b border-gray-200">
                <div className="flex items-center justify-between">
                  <h3 className="text-lg font-semibold text-gray-900">
                    Cadastrar Novo {tipoCadastro === 'produto' ? 'Produto' : 'Serviço'}
                  </h3>
                  <button
                    onClick={() => setMostrarModalCadastro(false)}
                    className="text-gray-400 hover:text-gray-600 w-6 h-6 flex items-center justify-center"
                  >
                    <i className="ri-close-line text-xl"></i>
                  </button>
                </div>
              </div>

              <form onSubmit={handleCadastrarItem} className="p-6 space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Código <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    value={novoCodigo}
                    onChange={(e) => setNovoCodigo(e.target.value)}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                    placeholder={`Digite o código do ${tipoCadastro === 'produto' ? 'produto' : 'serviço'}`}
                    required
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Descrição <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    value={novaDescricao}
                    onChange={(e) => setNovaDescricao(e.target.value)}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                    placeholder={`Digite a descrição do ${tipoCadastro === 'produto' ? 'produto' : 'serviço'}`}
                    required
                  />
                </div>

                <div className="flex space-x-3 pt-4">
                  <button
                    type="button"
                    onClick={() => setMostrarModalCadastro(false)}
                    className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Cancelar
                  </button>
                  <button
                    type="submit"
                    className="flex-1 px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Cadastrar
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
}
